/**
 * SOLID Review
 * S — Strong. One concern: a use case with no rule and nothing to keep — the server's or the platform's answer as it came.
 * O — Strong. The call is handed in; nothing here names one.
 * L — Strong. Implements its use-case role exactly.
 * I — Strong. `execute`.
 * D — Strong. The call, injected.
 */
import type { IContextRequest } from '../ports/IContextRequest';
import type { IUseCase } from '../uml-components/IUseCase';

/** The one call a pass-through makes. */
type TPassThroughCall<TCommand, TResult> = (ctx: IContextRequest, command: TCommand) => Promise<TResult>;

/**
 * A PASS-THROUGH (frontend-application-oo P4, 2026-10-28): a read or an act the Domain has no rule for and the client keeps
 * nothing of — the referral's verdict, the legal documents, the consent platform's own acts, a checkout, a health probe,
 * LiveKit's signaling. Each is one call through a socket, answered as it came, so each is an instance of this class rather
 * than a class of its own (as one-step decisions are `DecisionStep`s).
 */
export class PassThroughUseCase<TCommand, TResult> implements IUseCase<TCommand, TResult> {
  constructor(private readonly call: TPassThroughCall<TCommand, TResult>) {}

  execute(ctx: IContextRequest, command: TCommand): Promise<TResult> {
    return this.call(ctx, command);
  }
}
